export const PROFILES_BY_USERNAME = (username) => `profiles/${username}`;
export const FOLLOW_UNFOLLOW_PROFILE = (username) => `profiles/${username}/follow`;
